import React, { useState, useEffect, useRef } from 'react';
import '../ProjectsStyles/Projects.css';

const projects = [
  {
    id: 1,
    title: 'Mayura Travels',
    category: 'Web App',
    categoryId: 'web',
    icon: 'bi-airplane',
    accent: '#4FA8F5',
    description: 'A comprehensive travel booking platform designed to simplify trip planning with intuitive UI, real-time booking capabilities, and seamless customer interaction. Built with scalability in mind, it ensures reliable performance and smooth navigation.',
    highlights: [
      'Real-time booking & availability',
      'Intuitive trip planning UI',
      'Seamless customer interaction',
      'Scalable cloud architecture',
      'Smooth cross-device navigation',
    ],
    url: 'https://mayooratravels.bellaryinfotech.com',
    status: 'Live',
  },
  {
    id: 2,
    title: 'Megha Super Structures',
    category: 'Web App',
    categoryId: 'web',
    icon: 'bi-buildings',
    accent: '#2DD4A7',
    description: 'A dynamic web platform for construction and vehicle rental services, showcasing projects, managing rentals, and enhancing customer engagement through a structured and modern interface.',
    highlights: [
      'Project showcase gallery',
      'Vehicle rental management',
      'Customer engagement portal',
      'Modern structured interface',
      'Mobile-responsive design',
    ],
    url: 'https://meghass.bellaryinfotech.com',
    status: 'Live',
  },
  {
    id: 3,
    title: 'Omex Technology Inc',
    category: 'Corporate',
    categoryId: 'web',
    icon: 'bi-globe2',
    accent: '#8B7CF6',
    description: 'A professional corporate website for a US-based software company, focusing on branding, service presentation, and client acquisition with a clean and responsive design.',
    highlights: [
      'Professional US-market branding',
      'Service presentation pages',
      'Client acquisition funnels',
      'Clean responsive design',
      'SEO-optimized structure',
    ],
    url: 'https://www.omextechnologyinc.com',
    status: 'Live',
  },
  {
    id: 4,
    title: 'Cloudtris',
    category: 'Cloud',
    categoryId: 'cloud',
    icon: 'bi-cloud-fill',
    accent: '#4FA8F5',
    description: 'An enterprise-grade website tailored for a cloud solutions provider, emphasizing scalability, service offerings, and global client reach with optimized performance.',
    highlights: [
      'Enterprise-grade architecture',
      'Cloud service showcase',
      'Global client reach focus',
      'Performance optimized',
      'Scalable infrastructure design',
    ],
    url: 'https://www.cloudtris.in',
    status: 'Live',
  },
  {
    id: 5,
    title: 'OpenGen',
    category: 'Developer Tools',
    categoryId: 'devtools',
    icon: 'bi-code-slash',
    accent: '#2DD4A7',
    description: 'A full-stack developer advocacy platform enabling tutorials, video uploads, and community interaction, designed to support developers with rich content and engagement tools.',
    highlights: [
      'Tutorial & content platform',
      'Video upload capabilities',
      'Community interaction system',
      'Developer advocacy tools',
      'Rich engagement features',
    ],
    url: 'https://www.opengen.tech',
    status: 'Live',
  },
  {
    id: 6,
    title: 'Sibaranjan.cloud',
    category: 'Fintech',
    categoryId: 'fintech',
    icon: 'bi-currency-exchange',
    accent: '#FB923C',
    description: 'A fintech web application offering financial advisory services with secure payment integration and real-time appointment scheduling for enhanced user experience.',
    highlights: [
      'Financial advisory services',
      'Secure payment integration',
      'Real-time appointment scheduling',
      'Data security compliance',
      'Enhanced user experience',
    ],
    url: 'https://www.sibaranjan.cloud',
    status: 'Live',
  },
  {
    id: 7,
    title: 'Mob Services',
    category: 'Web App',
    categoryId: 'web',
    icon: 'bi-phone-fill',
    accent: '#F472B6',
    description: 'A mobile services management platform designed for efficient service tracking, customer interaction, and streamlined operations with a focus on usability.',
    highlights: [
      'Service tracking system',
      'Customer interaction portal',
      'Streamlined operations dashboard',
      'Mobile-first design approach',
      'Efficient management tools',
    ],
    url: 'https://mozmobile.bellaryinfotech.com',
    status: 'Live',
  },
  {
    id: 8,
    title: 'Internal Billing Product',
    category: 'Enterprise',
    categoryId: 'enterprise',
    icon: 'bi-receipt-cutoff',
    accent: '#8B7CF6',
    description: 'A robust internal full-stack application handling billing, taxation, and financial workflows with high accuracy and performance for enterprise operations.',
    highlights: [
      'GST-compliant billing engine',
      'Taxation management module',
      'Financial workflow automation',
      'High-accuracy processing',
      'Full-stack enterprise architecture',
    ],
    url: null,
    status: 'Internal',
  },
  {
    id: 9,
    title: 'Testing & API Services',
    category: 'Enterprise',
    categoryId: 'enterprise',
    icon: 'bi-shield-check',
    accent: '#2DD4A7',
    description: 'Advanced testing solutions including API validation, automation, and quality assurance for enterprise-grade applications, serving high-standard clients.',
    highlights: [
      'API validation & testing',
      'Test automation frameworks',
      'Quality assurance processes',
      'Enterprise-grade standards',
      'High-standard client support',
    ],
    url: null,
    status: 'Confidential',
  },
  {
    id: 10,
    title: 'Quality Billing',
    category: 'Enterprise',
    categoryId: 'enterprise',
    icon: 'bi-cash-stack',
    accent: '#F2B705',
    description: 'An internal billing engine purpose-built for recurring billing and revenue billing, automating subscription cycles, invoice generation, and revenue recognition with precision and full audit traceability.',
    highlights: [
      'Recurring & subscription billing',
      'Automated revenue billing',
      'Invoice generation engine',
      'Revenue recognition tracking',
      'Audit-ready financial logs',
    ],
    url: null,
    status: 'Internal',
  },
];

const testimonials = [
  {
    name: 'Rahul Mayura',
    role: 'Founder, Mayura Travels',
    project: 'Mayura Travels',
    accent: '#4FA8F5',
    initials: 'RM',
    rating: 5,
    quote: 'Our booking volume jumped within weeks of launch. The platform feels effortless for our customers and the team behind it actually listens.',
  },
  {
    name: 'Anitha Reddy',
    role: 'Operations Head, Megha Super Structures',
    project: 'Megha Super Structures',
    accent: '#2DD4A7',
    initials: 'AR',
    rating: 5,
    quote: 'Managing rentals and showcasing projects used to be two separate headaches. Bellary brought it into one clean, reliable system.',
  },
  {
    name: 'David Cohen',
    role: 'VP Marketing, Omex Technology Inc',
    project: 'Omex Technology Inc',
    accent: '#8B7CF6',
    initials: 'DC',
    rating: 5,
    quote: 'A genuinely polished site that helped us land US clients faster. The branding work alone was worth the engagement.',
  },
  {
    name: 'Priya Nair',
    role: 'CTO, Cloudtris',
    project: 'Cloudtris',
    accent: '#4FA8F5',
    initials: 'PN',
    rating: 5,
    quote: 'Performance and scale were non-negotiable for us. The Bellary team delivered an architecture that hasn\'t blinked under load.',
  },
  {
    name: 'Marcus Webb',
    role: 'Developer Relations, OpenGen',
    project: 'OpenGen',
    accent: '#2DD4A7',
    initials: 'MW',
    rating: 5,
    quote: 'Our community engagement tripled after the new platform shipped. Video uploads and tutorials just work, every time.',
  },
  {
    name: 'Sibaranjan Patro',
    role: 'Founder, Sibaranjan.cloud',
    project: 'Sibaranjan.cloud',
    accent: '#FB923C',
    initials: 'SP',
    rating: 5,
    quote: 'Secure payments and scheduling needed to feel instant for clients. That\'s exactly what we got, with zero compromises on security.',
  },
  {
    name: 'Lakshmi Iyer',
    role: 'Ops Manager, Mob Services',
    project: 'Mob Services',
    accent: '#F472B6',
    initials: 'LI',
    rating: 5,
    quote: 'Service tracking finally feels streamlined. Our field team adopted it on day one because it was built around how we actually work.',
  },
  {
    name: 'Kiran Desai',
    role: 'Finance Director, Internal Billing Product',
    project: 'Internal Billing',
    accent: '#8B7CF6',
    initials: 'KD',
    rating: 5,
    quote: 'GST compliance and taxation used to eat up our week. The automation Bellary built gave that time straight back to the team.',
  },
  {
    name: 'Sophia Tan',
    role: 'QA Lead, Testing & API Services',
    project: 'Testing & API Services',
    accent: '#2DD4A7',
    initials: 'ST',
    rating: 5,
    quote: 'Their testing frameworks caught issues our previous vendor missed for months. Quality and confidentiality, handled perfectly.',
  },
  {
    name: 'Naveen Kumar',
    role: 'Revenue Manager, Quality Billing',
    project: 'Quality Billing',
    accent: '#F2B705',
    initials: 'NK',
    rating: 5,
    quote: 'Recurring billing used to mean spreadsheets and errors. Now revenue recognition runs itself and every invoice is audit-ready.',
  },
  {
    name: 'Emily Carter',
    role: 'Product Owner, Omex Technology Inc',
    project: 'Omex Technology Inc',
    accent: '#8B7CF6',
    initials: 'EC',
    rating: 5,
    quote: 'Clear communication, fast turnarounds, and a team that treats your product like their own. Couldn\'t ask for more.',
  },
  {
    name: 'Arjun Mehta',
    role: 'IT Director, Cloudtris',
    project: 'Cloudtris',
    accent: '#4FA8F5',
    initials: 'AM',
    rating: 5,
    quote: 'We evaluated three vendors before Bellary. None of them matched their technical depth or their honesty about timelines.',
  },
];

const filters = [
  { id: 'all', label: 'All Projects', icon: 'bi-grid-fill' },
  { id: 'web', label: 'Web Apps', icon: 'bi-display' },
  { id: 'cloud', label: 'Cloud & Fintech', icon: 'bi-cloud-fill' },
  { id: 'enterprise', label: 'Enterprise', icon: 'bi-building' },
  { id: 'devtools', label: 'Developer Tools', icon: 'bi-code-slash' },
];

const matchesFilter = (project, filterId) => {
  if (filterId === 'all') return true;
  if (filterId === 'cloud') return project.categoryId === 'cloud' || project.categoryId === 'fintech';
  return project.categoryId === filterId;
};

const statusConfig = {
  Live: { color: '#0E9E78', bg: '#D7F7EC' },
  Internal: { color: '#B45309', bg: '#FFE9D6' },
  Confidential: { color: '#6B7280', bg: '#F1F0F4' },
};

const TestimonialCard = ({ t }) => (
  <div className="test-card">
    <div className="test-card-top">
      <div className="test-quote-icon" style={{ background: `${t.accent}1A`, color: t.accent }}>
        <i className="bi bi-quote"></i>
      </div>
      <div className="test-stars">
        {Array.from({ length: t.rating }).map((_, i) => (
          <i key={i} className="bi bi-star-fill"></i>
        ))}
      </div>
    </div>
    <p className="test-quote">"{t.quote}"</p>
    <div className="test-card-footer">
      <div className="test-avatar" style={{ background: t.accent }}>{t.initials}</div>
      <div>
        <div className="test-person-name">{t.name}</div>
        <div className="test-person-role">{t.role}</div>
      </div>
      <span className="test-project-tag" style={{ color: t.accent }}>{t.project}</span>
    </div>
  </div>
);

const TestimonialsSection = () => {
  const row1 = testimonials.slice(0, 6);
  const row2 = testimonials.slice(6, 12);

  return (
    <section className="test-section">
      <div className="test-blob test-blob1"></div>
      <div className="test-blob test-blob2"></div>
      <div className="test-blob test-blob3"></div>

      <div className="test-header">
        <span className="test-eyebrow">Client Feedback</span>
        <h2 className="test-title">
          What Our Clients Say <span className="grad-text">About Bellary</span>
        </h2>
        <p className="test-subtitle">
          Real feedback from the founders, leads, and teams behind every project we've shipped.
        </p>
      </div>

      <div className="test-marquee-wrap">
        <div className="test-track">
          {[...row1, ...row1].map((t, i) => (
            <TestimonialCard key={`r1-${i}`} t={t} />
          ))}
        </div>
        <div className="test-track test-track-reverse">
          {[...row2, ...row2].map((t, i) => (
            <TestimonialCard key={`r2-${i}`} t={t} />
          ))}
        </div>
      </div>
    </section>
  );
};

const ProjectsGrid = () => {
  const [activeFilter, setActiveFilter] = useState('all');
  const [selectedProject, setSelectedProject] = useState(null);
  const cardRefs = useRef([]);

  const filtered = projects.filter(p => matchesFilter(p, activeFilter));

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('prj-card-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.08, rootMargin: '0px 0px -40px 0px' }
    );
    cardRefs.current.forEach(el => el && observer.observe(el));
    return () => observer.disconnect();
  }, [filtered]);

  useEffect(() => {
    if (selectedProject) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => { document.body.style.overflow = ''; };
  }, [selectedProject]);

  const handleCardClick = (project) => {
    if (project.url) {
      window.open(project.url, '_blank', 'noopener,noreferrer');
    } else {
      setSelectedProject(project);
    }
  };

  return (
    <>
      <section className="prj-grid-section">
        <div className="prj-grid-inner">

          <div className="prj-section-header">
            <div className="section-eyebrow">
              <span>Portfolio</span>
            </div>
            <h2 className="prj-section-title">
              Smart, Scalable &amp; <span className="grad-text">Reliable Solutions</span>
            </h2>
            <p className="prj-section-subtitle">
              Every project we build is a testament to our engineering standards, client focus, and passion for technology.
            </p>
          </div>

          <div className="prj-filters" role="tablist" aria-label="Project filters">
            {filters.map(f => (
              <button
                key={f.id}
                role="tab"
                aria-selected={activeFilter === f.id}
                className={`prj-filter-btn ${activeFilter === f.id ? 'prj-filter-active' : ''}`}
                onClick={() => setActiveFilter(f.id)}
              >
                <i className={`bi ${f.icon}`}></i>
                <span>{f.label}</span>
              </button>
            ))}
          </div>

          <p className="prj-count">
            Showing <strong>{filtered.length}</strong> project{filtered.length !== 1 ? 's' : ''}
          </p>

          <div className="prj-cards-grid">
            {filtered.map((project, i) => {
              const st = statusConfig[project.status];
              return (
                <article
                  key={project.id}
                  className="prj-card"
                  ref={el => cardRefs.current[i] = el}
                  style={{ '--prj-accent': project.accent, animationDelay: `${i * 0.08}s` }}
                  onClick={() => handleCardClick(project)}
                  tabIndex={0}
                  role="button"
                  aria-label={`View ${project.title}`}
                  onKeyDown={e => (e.key === 'Enter' || e.key === ' ') && handleCardClick(project)}
                >
                  <div className="prj-card-top">
                    <div className="prj-card-icon" style={{ background: `${project.accent}18`, color: project.accent }}>
                      <i className={`bi ${project.icon}`}></i>
                    </div>
                    <span
                      className="prj-card-status"
                      style={{ color: st.color, background: st.bg }}
                    >
                      {project.status === 'Live' && <span className="prj-live-dot" style={{ background: st.color }}></span>}
                      {project.status}
                    </span>
                  </div>

                  <span className="prj-card-cat">{project.category}</span>

                  <h3 className="prj-card-title">{project.title}</h3>

                  <p className="prj-card-desc">{project.description}</p>

                  <ul className="prj-card-highlights">
                    {project.highlights.slice(0, 3).map((h, hi) => (
                      <li key={hi}>
                        <i className="bi bi-check-circle-fill" style={{ color: project.accent }}></i>
                        {h}
                      </li>
                    ))}
                  </ul>

                  <div className="prj-card-footer">
                    {project.url ? (
                      <span className="prj-card-link">
                        Visit Project <i className="bi bi-arrow-up-right"></i>
                      </span>
                    ) : (
                      <span className="prj-card-link prj-card-link-info">
                        View Details <i className="bi bi-info-circle"></i>
                      </span>
                    )}
                    <div className="prj-card-bar"></div>
                  </div>
                </article>
              );
            })}
          </div>
        </div>

        {selectedProject && (
          <div
            className="prj-modal-overlay"
            onClick={(e) => e.target === e.currentTarget && setSelectedProject(null)}
            role="dialog"
            aria-modal="true"
            aria-label={`${selectedProject.title} details`}
          >
            <div className="prj-modal">
              <button
                className="prj-modal-close"
                onClick={() => setSelectedProject(null)}
                aria-label="Close"
              >
                <i className="bi bi-x-lg"></i>
              </button>

              <div className="prj-modal-header" style={{ '--prj-accent': selectedProject.accent }}>
                <div className="prj-modal-icon" style={{ background: `${selectedProject.accent}20`, color: selectedProject.accent }}>
                  <i className={`bi ${selectedProject.icon}`}></i>
                </div>
                <div>
                  <span className="prj-card-cat">{selectedProject.category}</span>
                  <h2 className="prj-modal-title">{selectedProject.title}</h2>
                  <span
                    className="prj-card-status"
                    style={{ color: statusConfig[selectedProject.status].color, background: statusConfig[selectedProject.status].bg }}
                  >
                    {selectedProject.status}
                  </span>
                </div>
              </div>

              <p className="prj-modal-desc">{selectedProject.description}</p>

              <h3 className="prj-modal-feat-title">Key Features</h3>
              <ul className="prj-modal-features">
                {selectedProject.highlights.map((h, i) => (
                  <li key={i}>
                    <i className="bi bi-check-circle-fill" style={{ color: selectedProject.accent }}></i>
                    {h}
                  </li>
                ))}
              </ul>

              <div className="prj-modal-footer">
                {selectedProject.url ? (
                  <a
                    href={selectedProject.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="prj-modal-btn"
                    style={{ background: selectedProject.accent }}
                  >
                    Visit Project <i className="bi bi-arrow-up-right"></i>
                  </a>
                ) : (
                  <div className="prj-modal-restricted">
                    <i className="bi bi-lock-fill"></i>
                    {selectedProject.status === 'Internal' ? 'This is an internal product — not publicly accessible.' : 'This project is confidential and not publicly accessible.'}
                  </div>
                )}
                <button className="prj-modal-btn-ghost" onClick={() => setSelectedProject(null)}>
                  Close
                </button>
              </div>
            </div>
          </div>
        )}
      </section>

      <TestimonialsSection />
    </>
  );
};

export default ProjectsGrid;